import {formatDecimal} from '../util/util';

export const amount = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML = formatDecimal(binding.value);
        } else {
            el.innerHTML = null
        }

    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML = formatDecimal(binding.value);
        } else {
            el.innerHTML = null
        }
    }
};




// WEBPACK FOOTER //
// ./src/directives/amount.js